(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Initialize Yotpo widgets when filters are applied or removed
  document.addEventListener('filter:update', () => {
    // Wait for DOM to update with filtered results before initializing Yotpo widgets
    let initialized = false;
    const initYotpo = () => {
      if (initialized) return;
      initialized = true;
      if (typeof window.yotpoWidgetsContainer !== 'undefined' && window.yotpoWidgetsContainer.initWidgets) {
        window.yotpoWidgetsContainer.initWidgets();
      }
    };
    
    // Use MutationObserver to detect when the product grid actually updates
    const resultsList = document.querySelector('results-list');
    if (!resultsList) {
      // Fallback if results-list not found
      setTimeout(initYotpo, 300);
      return;
    }
    
    const productGrid = resultsList.querySelector('[ref="grid"]');
    if (!productGrid) {
      // Fallback if grid not found
      setTimeout(initYotpo, 300);
      return;
    }
    
    // Create a MutationObserver to detect when the grid updates
    const observer = new MutationObserver(() => {
      // Disconnect after first change is detected
      observer.disconnect();
      // Initialize Yotpo widgets after a brief delay to ensure DOM is fully updated
      setTimeout(initYotpo, 100);
    });
    
    // Observe the grid for child list changes (when products are added/removed)
    observer.observe(productGrid, {
      childList: true,
      subtree: false
    });
    
    // Fallback timeout in case mutation observer doesn't fire
    setTimeout(() => {
      observer.disconnect();
      initYotpo();
    }, 1000);
  });

  } catch(e) { console.error(e); }
})();
})();
